import React from 'react';

const MobileAboutPage: React.FC = () => {
  return (
    <div className="p-6 max-w-md mx-auto animate-fade-in">
        <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-cyan-400 mb-2">About RaceLineIQ</h1>
            <p className="text-lg text-gray-300">
              The first product that puts your performance on competition day into context.
            </p>
        </div>
        
        <div className="space-y-6 text-gray-300 text-base leading-relaxed">
            <p>
              For competitive athletes, RaceLineIQ is a tactical visualization platform that crowdsources athlete data to reconstruct the race.
            </p>
            <p>
              Unlike standard fitness apps that show only personal metrics, we create a digital twin of the event, showing you exactly where you won or lost the race relative to your competition.
            </p>
            <p className="font-semibold text-white">
              Our mission is to enable competitive athletes to reach their highest potential.
            </p>
        </div>

        <div className="mt-10 text-center">
            <div className="text-2xl font-bold text-white">
                RaceLine<span className="text-cyan-400">IQ</span>
            </div>
        </div>
    </div>
  );
};

export default MobileAboutPage;